module.exports = __webpack_public_path__ + "img/icon_login_social_kakao.d93c7294.svg";